import type { TImageCard } from '@/src/elements/card/image'

import type { TMessageId } from '@/translations/translations.types'

enum GUIDE_TYPE {
  PRAYER = 'prayer',
  BIBLE = 'bible',
  FEAST = 'feast',
  SAINTS = 'saints',
  CATECHISM = 'catechism',
  MIRACLES = 'miracles',
  ROSARY = 'rosary',
  MEDITATION = 'meditation',
}

export const guideUrls: Record<TLocale, Partial<Record<GUIDE_TYPE, string>>> = {
  fr: {
    [GUIDE_TYPE.PRAYER]: '/priere',
    [GUIDE_TYPE.FEAST]: '/fetes',
    [GUIDE_TYPE.BIBLE]: '/bible',
    [GUIDE_TYPE.SAINTS]: '/saints',
    [GUIDE_TYPE.CATECHISM]: '/catechisme',
    [GUIDE_TYPE.MIRACLES]: '/miracles-et-apparitions',
    [GUIDE_TYPE.ROSARY]: '/chapelet',
    [GUIDE_TYPE.MEDITATION]: '/meditation',
  },
  en: {
    [GUIDE_TYPE.PRAYER]: '/en/prayer',
    [GUIDE_TYPE.FEAST]: '/en/feast',
    [GUIDE_TYPE.BIBLE]: '/en/bible',
    [GUIDE_TYPE.SAINTS]: '/en/saints',
    [GUIDE_TYPE.ROSARY]: '/en/rosary',
    [GUIDE_TYPE.CATECHISM]: '/en/catechism',
    [GUIDE_TYPE.MIRACLES]: '/en/miracles-and-apparitions',
    [GUIDE_TYPE.MEDITATION]: '/en/meditation',
  },
  es: {
    [GUIDE_TYPE.PRAYER]: '/es/oracion',
    [GUIDE_TYPE.FEAST]: '/es/fiestas',
    [GUIDE_TYPE.BIBLE]: '/es/biblia',
    [GUIDE_TYPE.SAINTS]: '/es/santos',
    [GUIDE_TYPE.ROSARY]: '/es/rosario',
    [GUIDE_TYPE.CATECHISM]: '/es/catecismo',
    [GUIDE_TYPE.MIRACLES]: '/es/milagros-y-apariciones',
    [GUIDE_TYPE.MEDITATION]: '/es/meditacion',
  },
  pt: {
    [GUIDE_TYPE.PRAYER]: '/pt/oracao',
    [GUIDE_TYPE.BIBLE]: '/pt/biblia',
    [GUIDE_TYPE.SAINTS]: '/pt/santos',
  },
  it: {
    [GUIDE_TYPE.PRAYER]: '/it/preghiera',
    [GUIDE_TYPE.FEAST]: '/it/feste',
    [GUIDE_TYPE.BIBLE]: '/it/bibbia',
    [GUIDE_TYPE.SAINTS]: '/it/santi',
    [GUIDE_TYPE.ROSARY]: '/it/rosario',
    [GUIDE_TYPE.MEDITATION]: '/it/meditazione',
  },
  pl: {
    [GUIDE_TYPE.PRAYER]: '/pl/modlitwa',
    [GUIDE_TYPE.BIBLE]: '/pl/biblia',
    [GUIDE_TYPE.SAINTS]: '/pl/swiety',
    [GUIDE_TYPE.ROSARY]: '/pl/rozaniec',
    [GUIDE_TYPE.MEDITATION]: '/pl/medytacja',
  },
}

export const guideImages: Record<GUIDE_TYPE, TImageCard['imageSrc']> = {
  [GUIDE_TYPE.PRAYER]: require('@/img/guide/prayer.jpg'),
  [GUIDE_TYPE.FEAST]: require('@/img/guide/feasts.jpg'),
  [GUIDE_TYPE.BIBLE]: require('@/img/guide/bible.jpg'),
  [GUIDE_TYPE.SAINTS]: require('@/img/guide/saints.jpg'),
  [GUIDE_TYPE.CATECHISM]: require('@/img/guide/catechism.jpg'),
  [GUIDE_TYPE.MIRACLES]: require('@/img/guide/miracles.jpg'),
  [GUIDE_TYPE.ROSARY]: require('@/img/guide/rosary.jpg'),
  [GUIDE_TYPE.MEDITATION]: require('@/img/guide/meditation.jpg'),
}

export const guideTexts: Record<GUIDE_TYPE, TMessageId> = {
  [GUIDE_TYPE.PRAYER]: 'app.navigation.footer.guide.prayer',
  [GUIDE_TYPE.FEAST]: 'app.navigation.footer.guide.feast-days',
  [GUIDE_TYPE.BIBLE]: 'app.navigation.footer.guide.bible',
  [GUIDE_TYPE.SAINTS]: 'app.navigation.footer.guide.saints',
  [GUIDE_TYPE.CATECHISM]: 'app.navigation.footer.guide.catechism',
  [GUIDE_TYPE.ROSARY]: 'app.navigation.footer.guide.rosary',
  [GUIDE_TYPE.MIRACLES]: 'app.navigation.footer.guide.miracles',
  [GUIDE_TYPE.MEDITATION]: 'app.navigation.footer.guide.meditation',
}
